var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriberPlanStarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 76,
    viewBox: "0 0 120 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00390625,
    width: 120,
    height: 75,
    rx: 8,
    fill: "url(#paint0_linear_12927_136983)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12927_136983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 76
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00390625,
    width: 120,
    height: 75,
    rx: 8,
    fill: "#ED713C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12927_136983)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.4952 90.8288C60.4952 101.225 53.1637 112.228 37.8624 121.103C22.7776 129.852 1.37795 135.535 -22.7178 135.535C-46.8135 135.535 -68.2132 129.852 -83.298 121.103C-98.5993 112.228 -105.931 101.225 -105.931 90.8288C-105.931 80.4324 -98.5993 69.4294 -83.298 60.5547C-68.2132 51.8055 -46.8135 46.1229 -22.7178 46.1229C1.37795 46.1229 22.7776 51.8055 37.8624 60.5547C53.1637 69.4294 60.4952 80.4324 60.4952 90.8288Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 16.9412
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M231.691 -12.4659C231.691 1.75289 223.477 15.4887 208.448 26.018C193.446 36.5289 172.27 43.2988 148.478 43.2988C124.687 43.2988 103.511 36.5289 88.5089 26.018C73.4803 15.4887 65.2655 1.75289 65.2655 -12.4659C65.2655 -26.6847 73.4803 -40.4204 88.5089 -50.9497C103.511 -61.4606 124.687 -68.2306 148.478 -68.2306C172.27 -68.2306 193.446 -61.4606 208.448 -50.9497C223.477 -40.4204 231.691 -26.6847 231.691 -12.4659Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 16.9412
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12927_136983",
    x1: 60.4138,
    y1: -12.4303,
    x2: 63.3412,
    y2: 84.3822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B768F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5057AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriberPlanStarter);
export default __webpack_public_path__ + "static/media/subscriber-plan-starter.f5ccf6d505ecab266846178cc196aa42.svg";
export { ForwardRef as ReactComponent };